/*eslint-disable*/
//流程模块接口设置
import {
  postRequest,
  postRequestParams,
  getRequest,
  fileUpload,
  postDataParams
} from '@/api/request' // 导入request中创建的axios实例
const flow = {
  getTaskInfo: id => { //获取流程任务信息-陈国贵
    return getRequest('workflow/getTaskInfo/' + id, {})
  },
  getChartCode: (code, version) => { //获取流程图-陈国贵
    return getRequest('/workflow/getChartCode/' + code + '/' + version, {})
  },
  getAuditHistoryList: code => { //查询审批历史记录-陈国贵
    return getRequest('/workflow/getAuditHistoryList/' + code, {})
  },
  taskLog: workflowCode => { //查询流程操作记录-陈国贵
    return getRequest("workflow/getTaskLog/" + workflowCode, {}, '');
  },
  audit: (flowCode, params) => { //流程审批操作-陈国贵
    return postRequest("workflow/audit/" + flowCode, params);
  },
  gqAudit: (flowCode, params) => { //流程审批操作-陈国贵
    return postRequest("workflow/hangup/" + flowCode, params);
  },
  getPrintWorkflowList: params => { //获取打印的流程历史记录接口-陈国贵
    return getRequest("workflow/getPrintWorkflowList", params);
  },

  getAuditUser: (id, type) => { //获取当前审核人-陈国贵
    return getRequest("workflow/getAuditUser/" + id + '/' + type, {});
  },

  getCurrentNode: (workflowCode) => { //  查询流程当前节点信息-陈国贵
    return getRequest("workflow/getCurrentNode/" + workflowCode, {});
  },

  getCheckAuditUser: (params) => { // 判断当前登录人是不是审核人-陈国贵   微信用
    return postRequestParams("workflow/checkAuditUser",params);
  },
}
export default {
  flow
}